import { LocalStorageKey } from '@/constants/storages';
import { getLocalStorageItem } from '@/helpers/storage';
import { stringify } from '@/helpers/string';

export const convertQueryStringToObject = (queryString: string) => {
  if (!queryString) {
    return '';
  }
  return JSON.parse(`{"${decodeURI(queryString.substring(1)).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"')}"}`);
};

const getSearchConfig = () => {
  const searchObj = convertQueryStringToObject(window.location.search);
  if (searchObj && (searchObj?.shop || searchObj?.store)) {
    return window.location.search;
  }
  return getLocalStorageItem(LocalStorageKey.LOGIN_QUERY_STRING) || '';
};
const searchConfig = getSearchConfig();

const getUrlParameter = (sParam: string): string => {
  const urlSearchParams = new URLSearchParams(searchConfig);
  return urlSearchParams.get(sParam) || '';
};

const getUrlParameterJson = (): string => {
  const search = searchConfig.substring(1);
  if (search !== '') {
    var urlParams = JSON.parse('{"' + search.replace(/&/g, '","').replace(/=/g, '":"') + '"}', function (key, value) {
      return key === '' ? value : decodeURIComponent(value);
    });
    return stringify(urlParams);
  }
  return '';
};

export const config = {
  shop: getUrlParameter('shop') || getUrlParameter('store'),
  urlParams: getUrlParameterJson(),
  loginQueryString: searchConfig,
  embedded: getUrlParameter('embedded'),
  hmac: getUrlParameter('hmac'),
  host: getUrlParameter('host'),
  source: getUrlParameter('source'),
  token: getUrlParameter('token'),
  locale: getUrlParameter('locale'),
  session: getUrlParameter('session'),
  timestamp: getUrlParameter('timestamp'),
  scope: getUrlParameter('scope'),
  role: getUrlParameter('role'),
  APP_VERSION_2: '2.0.0',
  APP_VERSION_3: '3.0.0',
  DEFAULT_TOAST_DURATION: 1000,
  SAME_DAY_VALUE: -1,
  shopifySaveBarId: 'dingdoong_shopify_save_bar',
  storeName: (getUrlParameter('shop') || getUrlParameter('store')).split('.')[0]
};
